import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ProfileAPI } from "pages/profile/profile.service";
const initialState = {
  data: null,
  state: ""
};
export const timesheetCountSlice = createSlice({
  name: "timeSheetCount",
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder
      .addCase(getTimeSheetCount.fulfilled, (state, action) => {
        state.data = action.payload;
        state.state = "success";
      })
      .addCase(getTimeSheetCount.pending, (state, action) => {
        state.state = "pending";
      });
  }
});

export const getTimeSheetCount = createAsyncThunk('timesheetCount/get', async(query) => {
  let data = await ProfileAPI.getWorklogsCount();
  return data['totalCount'];

});


export default timesheetCountSlice.reducer;